











































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import Todo from '../models/Todo';
import Todos from '../models/Todos';
import SortOrders from '../models/SortOrders';

@Component
export default class TodoList extends Vue {
  name: string = 'TodoList';
  columns: string[] = ['id', 'tag', 'todo', 'complete', 'delete'];
  styleForSelectedRow: object = {'background-color': '#C0C0C0'};
  styleForNonSelectedEvenRow: object = {'background-color': '#FFFFFF'};
  styleForNonSelectedOddRow: object = {'background-color': '#F5F5F5'};

  sortOrders: SortOrders = new SortOrders();
  todos: Todos = Todos.getInstance();

  searchQuery: string = '';
  sortKey: string = 'キー';
  selectedId: number = -1;
  tag: string = '';
  todo: string = '';

  // computed
  get Todos(): Todo[] {
    let ret: Todo[] = this.todos.getTodos();
    const filterKey: string = this.searchQuery && this.searchQuery.toLowerCase();
    if (filterKey) {
      ret = ret.filter((row: Todo) => {
        return row.isIncluded(filterKey);
      });
    }
    const order = this.sortOrders.getOrder(this.sortKey) || -1;
    ret = ret.slice().sort((a: Todo, b: Todo) => {
      const aVal: string = a.getValue(this.sortKey);
      const bVal: string = b.getValue(this.sortKey);
      return (aVal === bVal ? 0 : aVal > bVal ? 1 : -1) * order;
    });
    return ret;
  }

  sortBy(key: string): void {
    this.sortKey = key;
    this.sortOrders.selectKey(this.sortKey);
  }
  edit(id: number): void {
    this.selectedId = id;
  }
  async addTodo(): Promise<any> {
    await this.todos.addTodo( new Todo(0, this.tag, this.todo, false));
    this.tag = this.todo = '';
  }
  async deleteTodo(target: Todo): Promise<any> {
    await this.todos.deleteTodo(target);
  }
  completed(todo: Todo): void {
    this.$nextTick(() => {
      this.todos.updateTodo(todo);
    });
  }
  async created(): Promise<void> {
    await this.todos.init();
  }
}
